import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { PublicService } from '../services/public.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard {

  constructor(private router: Router, private publicService: PublicService) { }

  canActivate() {
    const user = localStorage.getItem(this.publicService.getActiveUserKey());
    if (user) {
      return true;
    }

    this.router.navigate(['/auth/login']);
    return false;
  }
}
